import { useNavigate } from 'react-router-dom';

const SPLASH_BG = 'https://storage.helloreaddy.io/project_files/74e88f2c-3689-4ad7-91de-a011c3f37216/549a51dc-988b-4b02-a955-89d9501e0693_compressed_unnamed.webp';
const CENTER_LOGO = 'https://storage.helloreaddy.io/project_files/74e88f2c-3689-4ad7-91de-a011c3f37216/d4edc0ce-1ccb-42fa-aa9b-90a6adbe7e2d_compressed_unnamed.webp';

export default function Splash() {
  const navigate = useNavigate();

  const enterApp = () => {
    navigate('/home');
  };

  return (
    <div
      className="fixed inset-0 z-[100] overflow-hidden cursor-pointer"
      onClick={enterApp}
    >
      {/* 背景图 */}
      <img
        src={SPLASH_BG}
        alt="灵卦启示"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* 中心 LOGO —— 绝对定位确保精准居中 */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="relative -mt-8">
          <div className="animate-float bg-white/90 rounded-full p-4 shadow-[0_8px_32px_rgba(0,0,0,0.25)] border border-foreground-800/10">
            <img
              src={CENTER_LOGO}
              alt="太极八卦"
              className="w-28 h-28 object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
}